import React from 'react';
import MedicationSuccess from 'assets/common/medicationSucccess.png';
import s from './s.module.less';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

const PaymentSetupSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <img
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                    className={s.logo}
                    alt="Kiwi Health Logo"
                />
            </div>
            <div className={s.content}>
                <img src={MedicationSuccess} className={s.successImg} alt="Medication Success Icon" />
                <div className={s.title}>✅ Medication settings saved!</div>
                <div className={s.description}>
                    You’ve successfully set up your medication list. This helps ensure patients receive accurate care aligned with your treatment scope.
                </div>
                <div className={s.description}>
                    You’re all set! You can update these preferences anytime in your settings.
                </div>
                <Button
                    type="primary"
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                    size="large"
                    style={{ width: '353px' }}
                >Back to homepage
                </Button>
            </div>
        </div>
    );
};

export default PaymentSetupSuccess;
